import { Theme, css } from '@emotion/react';
import { mobileSearchBarHeight } from 'components/www/availability-search/searchResultsCssDefs';

export const searchBarMobile = (theme: Theme) => css`
  ${theme.breakpoints.up('sm')} {
    display: none;
  }
`;

export const searchBarMobileHeader = ({ colors, spacing }: Theme) => css`
  background-color: ${colors.bgDefault};
  padding: ${spacing(2)}px ${spacing(3)}px 0;
  border-top: 1px solid ${colors.borderDefault};
`;

export const searchBarMobileContainerLegacy = ({ colors, spacing }: Theme) => css`
  align-items: center;
  background-color: ${colors.bgDefault};
  border-bottom: 1px solid ${colors.borderDefault};
  display: flex;
  justify-content: flex-start;
  max-height: ${mobileSearchBarHeight};
  margin-right: ${spacing(2)}px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: ${spacing(1.5)}px ${spacing(2)}px ${spacing(1.5)}px;
  white-space: nowrap;
  width: 100%;
  & > * + * {
    margin-left: ${spacing(1)}px;
  }
`;

export const searchBarMobileContainer = ({ colors, spacing }: Theme) => css`
  align-items: center;
  background-color: ${colors.bgDefault};
  border-bottom: 1px solid ${colors.borderDefault};
  display: flex;
  justify-content: space-between;
  max-height: ${mobileSearchBarHeight};
  margin-right: ${spacing(2)}px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: ${spacing(1.5)}px ${spacing(2)}px ${spacing(1.5)}px;
  white-space: nowrap;
  width: 100%;

  // This ensures that right-padding is preserved at the end of the horizontally scrolling search bar.
  // Description of problem: https://www.brunildo.org/test/overscrollback.html
  // Solution: https://webplatform.news/issues/2019-08-07 (modified slighly)
  & > :last-child {
    position: relative;
    &::after {
      position: absolute;
      content: '';
      left: 100%;
      width: ${spacing(2)}px;
      height: 100%;
    }
  }

  & > * + * {
    margin-left: ${spacing(1)}px;
  }
`;
